import callAPiBase from './base';

const taxApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/taxList',
      method: 'GET',
      useToken: true,
      title: 'Tax - Get List',
      params,
    }),
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/taxList',
      method: 'GET',
      useToken: true,
      title: 'Tax - Get',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/taxCreate',
      method: 'POST',
      useToken: true,
      title: 'Tax - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/taxEdit',
      method: 'PATCH',
      useToken: true,
      title: 'Tax - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/taxDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Tax - Delete',
      params,
    }),
  attach: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/taxAttach',
      method: 'PUT',
      useToken: true,
      title: 'Tax - Attach',
      data,
    }),
  detach: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/taxDetach',
      method: 'DELETE',
      useToken: true,
      title: 'Tax - Detach',
      params,
    }),
};

export { taxApi };
export default taxApi;
